<template>
  <el-dialog
    top="0"
    class="dialog-full-medium"
    width="30%"
    title="请选择服务器"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :before-close="handleClose"
    @open="handleOpen"
    v-loading="detailLoading"
  >
    <div class="dialog__body">
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item prop="ecsInstanceId" label-width="0px" class="jr_form_radio">
          <el-radio-group v-model="form.ecsInstanceId">
            <template v-for="(item,index) in ecsList">
              <el-radio :key="index" :label="item.ecsInstanceId">{{item.ecsName ||''}}</el-radio>
            </template>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose()" :size="formSize" :loading="submitLoading">取消</el-button>
      <el-button
        type="primary"
        :size="formSize"
        @click="submit()"
        :loading="submitLoading"
      >
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getIpProxyConfigEcsList, setIpProxyConfigBindEip } from '@/api/service-ip';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    currentObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      title: '',
      submitLoading: false,
      form: {
        eipInstanceId: '',
        ecsInstanceId: '', // 服务器id
      },
      rules: {
        ecsInstanceId: [{ required: true, message: '请选择服务器', trigger: 'change' }],
      },
      ecsList: '', // 服务器列表
      detailLoading: false, // 加载状态
    };
  },
  methods: {
    // 服务器列表接口请求
    async _getIpProxyConfigEcsList() {
      try {
        this.detailLoading = true;
        const res = await getIpProxyConfigEcsList({ region: this.currentObj.regionDesc || '' });
        this.ecsList = res.data || [];
        this.detailLoading = false;
      } catch (error) {
        console.log(error);
        this.detailLoading = false;
        this.ecsList = [];
      }
    },
    // 关闭
    handleClose() {
      this.$emit('update:visible', false);
      this.submitLoading = false;
    },
    // 打开窗口前
    handleOpen() {
      this.$nextTick(async () => {
        const { ipId } = this.currentObj;
        this.form = {
          eipInstanceId: ipId || '',
          ecsInstanceId: '', // 服务器id
        };
        this.$refs.form.resetFields();
        this._getIpProxyConfigEcsList();
      });
    },
    // 提交
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.submitLoading = true;
            await setIpProxyConfigBindEip(this.form);
            this.$message.success('绑定成功！！');
            this.submitLoading = false;
            this.handleClose();
            this.$emit('success');
          } catch (error) {
            console.log(error);
            this.submitLoading = false;
          }
        }
      });
    },
  },

};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog {
    min-width: 500px;
  }
  .content {
    margin-right: 0;
  }
  .el-radio {
    margin-top: 10px;
  }
}
</style>
